import * as React from 'react';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import Card from '@mui/joy/Card';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import TwoSidedLayout from '../components/TwoSidedLayout';
import { routes, RouterLink } from '../router';

export default function HeroLeft07() {
  return (
    <TwoSidedLayout>
      <Typography
        level="h1"
        fontWeight="xl"
        fontSize="clamp(1.875rem, 1.3636rem + 2.1818vw, 3rem)"
      >
        Easycart Minimercados
      </Typography>
      <Typography fontSize="lg" textColor="text.secondary" lineHeight="lg">
      Baseada em tecnologia e focada nos minimercados autônomos, a EasyCart oferece a comodidade que seus clientes merecem.
      </Typography>
      <Card
        variant="outlined"
        color="neutral"
        orientation="horizontal"
        sx={{ gap: 2, my: 1, textAlign: 'left' }}
      >
        <AutoAwesomeIcon color="success"  />
        <div>
          <Typography fontSize="xl" fontWeight="lg" sx={{ mb: 1 }}>
         Desfrute da comodidade exclusiva da nossa plataforma.
          </Typography>
        </div>
      </Card>
      <Button size="lg" onClick={()=> window.location.replace("https://www.onelink.to/easycart")}>Baixe nosso aplicativo</Button>
      <Typography
        level="body-xs"
        sx={{
          position: 'absolute',
          top: '2rem',
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      >
       CNPJ: 40.919.822/0001-95
       {" "}
       Contato: 45 9151-6789
      </Typography>
      <Box
        component="nav"
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: { xs: 'center', md: 'flex-start' },
          gap: 2,
          mt: 1,
        }}
      >
        <RouterLink to={routes.privacy} level="body-sm" color="neutral">
          Política de Privacidade
        </RouterLink>
        <RouterLink to={routes.terms} level="body-sm" color="neutral">
          Termos de Uso
        </RouterLink>
      </Box>
    </TwoSidedLayout>
  );
}
